import { FC } from 'react';

import { TagComponent } from 'components/tag/TagComponent';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { LearnerResultStatus } from '../core/enum';

interface Props {
  status: LearnerResultStatus;
}

export const LearnerResultStatusCard: FC<Props> = ({ status }) => {
  let color = 'grey';
  let title = 'Not started';

  switch (status) {
    case LearnerResultStatus.Completed:
      color = COLOR.green['green-7'];
      title = 'Completed';
      break;

    case LearnerResultStatus.Missed:
      color = COLOR_CONFIG.red;
      title = 'Missed';
      break;

    case LearnerResultStatus['In progress']:
      color = 'purple';
      title = 'In progress';
      break;
  }

  return <TagComponent color={color} text={title} />;
};
